import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { AppConstants } from "../constants/constants";
import { storeStorageReducer } from "./_store.meta-reducer";
import { storeEffects, storeReducers } from "./_store.state";


@NgModule({
    imports: [
        StoreModule.forRoot(storeReducers, {
            metaReducers: [ storeStorageReducer ]
        }),
        EffectsModule.forRoot(storeEffects),
        StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: window.location.href.includes(AppConstants.LOCALHOST)}),
    ]
})

export class CoreStoreModule {}